import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';
import { buildReservationSectionParams, type ReservationSectionParams } from '@/wabunka-src/common/utils/googleAnalytics/common/reservationSection';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type ReservationSectionEditParams = ReservationSectionParams;

/** 発火タイミング：新動線で畳まれたセクションの Edit を押したとき。押すたびに送る */
export const sendGAWabunkaReservationSectionEditEvent = (sectionId: ReservationSectionId) => {
  sendWabunkaGAEvent('reservation_section_edit', buildReservationSectionParams(sectionId));
};
